// Fetch list

export const FETCH = 'reportCostTypeCosts.FETCH'
export const FETCH_STARTED = 'reportCostTypeCosts.FETCH_STARTED'
export const FETCH_FULFILLED = 'reportCostTypeCosts.FETCH_FULFILLED'
export const FETCH_REJECTED = 'reportCostTypeCosts.FETCH_REJECTED'
export const FETCH_CANCELLED = 'reportCostTypeCosts.FETCH_CANCELLED'

// Export

export const EXPORT = 'reportCostTypeCosts.EXPORT'
export const EXPORT_FULFILLED = 'reportCostTypeCosts.EXPORT_FULFILLED'

// Clear

export const CLEAR = 'reportCostTypeCosts.CLEAR'

// Fetch details

export const FETCH_DETAILS = 'reportCostTypeCosts.FETCH_DETAILS'
export const FETCH_DETAILS_STARTED = 'reportCostTypeCosts.FETCH_DETAILS_STARTED'
export const FETCH_DETAILS_FULFILLED = 'reportCostTypeCosts.FETCH_DETAILS_FULFILLED'
export const FETCH_DETAILS_REJECTED = 'reportCostTypeCosts.FETCH_DETAILS_REJECTED'
export const FETCH_DETAILS_CANCELLED = 'reportCostTypeCosts.FETCH_DETAILS_CANCELLED'

// Export details

export const EXPORT_DETAILS = 'reportCostTypeCosts.EXPORT_DETAILS'
export const EXPORT_DETAILS_FULFILLED = 'reportCostTypeCosts.EXPORT_DETAILS_FULFILLED'

// Clear details

export const CLEAR_DETAILS = 'reportCostTypeCosts.CLEAR_DETAILS'
